import React from "react";
import Button from "../../atoms/button";
import Input from "../../atoms/input";
import { useFormContext } from "react-hook-form";
import type { LoginInput } from "../../../types/auth.types";
import { useMutation } from "@tanstack/react-query";
import type { OTPRequest } from "../../../@apis/dto/request/auth.request";
import { requestOtp } from "../../../@apis/v1/auth.service";
import { useModalStore } from "../../../lib/store/useModalStore";
import type { OnErrorResponse } from "../../../@apis/dto/response/common.response";
import { useNativeOtpAutofill } from "../../../hooks/useNativeOtpAutofill";

interface Props {
  request: boolean;
  setRequest: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function WithDrawTelecomScreen({ request, setRequest }: Props) {
  const { openModal } = useModalStore();

  const { register, watch, setValue } = useFormContext<LoginInput>();
  const values = watch();
  const { startListen } = useNativeOtpAutofill((otp) => {
    setValue("otp", otp, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  });

  const handleRequestOtp = () => {
    if (watch("mobileno").length < 10) return;
    startListen();
    deleteRequestOTPMuation.mutate({
      mobileno: watch("mobileno"),
    });
  };

  const deleteRequestOTPMuation = useMutation({
    mutationFn: (form: OTPRequest) => requestOtp(form),
    onSuccess: (res) => {
      const { success } = res;
      if (success) {
        register("mobileno").disabled = true;
        // clearAccess();
        //   clearMyInfo();
        return setRequest(true);
      }
    },
    onError: (err: OnErrorResponse) => {
      const { error } = err.response.data;
      openModal("ALERT_DIALOG", {
        title: request ? "인증번호 재발송 실패" : "인증번호 발송 실패",
        content:
          error?.code == "P018"
            ? "이미 인증번호를 발송하셨습니다.\n3분 후에 다시 시도해 주세요."
            : request
              ? "인증번호 재발송에 실패했습니다.\n잠시 후 다시 시도해 주세요."
              : "인증번호 발송에 실패했습니다.\n잠시 후 다시 시도해 주세요.",
      });
    },
  });

  return (
    <div className="">
      <div className="space-y-[10px] flex-1">
        <p className="font-bold pb-[10px]">휴대전화번호</p>
        <Input
          type="tel"
          inputMode="numeric"
          className="text-[0.7rem] placeholder:text-[0.7rem]"
          placeholder="전화번호 - 없이 입력"
          maxLength={11}
          {...register("mobileno", {
            onChange: (e) => {
              e.target.value = e.target.value
                .replace(/[^0-9]/g, "")
                .slice(0, 11);
            },
          })}
        />
        {request ? (
          <>
            <div className="flex flex-col gap-[10px] items-center">
              <Input
                inputMode="numeric"
                maxLength={6}
                autoComplete="one-time-code"
                className="min-w-0 text-[0.7rem] placeholder:text-[0.7rem]"
                placeholder="인증번호 6자리 입력"
                {...register("otp")}
              />
              <Button
                className="w-full break-keep text-xs"
                variant={"black"}
                label="인증 재요청"
                onClick={handleRequestOtp}
              />
            </div>
            {/* <p className="text-primary text-[12px] font-[500]">
                  인증에 성공했습니다.
                </p> */}
          </>
        ) : (
          <Button
            className="w-full text-white"
            disabled={values.mobileno.length < 10}
            variant={values.mobileno.length >= 10 ? "black" : "gray"}
            label="인증 요청"
            onClick={handleRequestOtp}
          />
        )}
      </div>
    </div>
  );
}
